/**
 * Validates a returnTo path from a query string to prevent open-redirect attacks.
 * Returns the path only if it's a safe, relative in-app navigation target.
 * Falls back to the provided default path otherwise.
 */
export const safeReturnTo = (returnTo, fallback) => {
    if (!returnTo)
        return fallback;
    if (!returnTo.startsWith("/") || returnTo.startsWith("//"))
        return fallback;
    if (/^\/[a-z]+:/i.test(returnTo))
        return fallback;
    return returnTo;
};
